import { Container, SectionMessage } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

export function PageNotFoundError() {
  const { t } = useTranslation();
  return (
    <Container>
      <SectionMessage
        sectionTitle={t("Page not found!")}
        type="info"
        icon="warning"
      />
    </Container>
  );
}
